import { useEffect } from "react";
import { Form, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import { partnershipTypes } from "../config";
import PartnerService from '../../../../../../services/PartnerService';
import Footer from "../../../../../../components/dashboards/components/project-visualisation/components/Footer";
import { licensingOptions } from "../../../../../DataStore/components/Settings/config";

export default function EditPartner({
  partner,
  onClose = () => { },
  fetchData = () => { },
}) {
  const { t } = useTranslation();
  const [MainForm] = Form.useForm();

  useEffect(() => {
    MainForm.setFieldsValue({ ...partner, licensing: 'no_citation' });
  }, [partner]);

  const onSubmit = async () => {
    try {
      const val = await MainForm.validateFields();
      await PartnerService.update(partner.id, val);
      onClose();
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Form form={MainForm} layout="vertical">
        <Form.Item
          required
          name="nickName"
          rules={[{ required: true }]}
          label={t('Name')}
        >
          <Input name="name" />
        </Form.Item>

        <Form.Item
          required
          name="partnershipType"
          label={t('Partner Type')}
        >
          <Select>
            {partnershipTypes.map((type) => (
              <Select.Option key={type.value} value={type.value}>
                {type.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          required
          name="email"
          label={t('Email address')}
          rules={[{ type: 'email', required: true }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          required
          name="licensing"
          label={t('Licensing')}
        >
          <Select disabled>
            {licensingOptions.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {t(option.label)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>

      <Footer
        t={t}
        onClose={onClose}
        onSubmit={onSubmit}
      />
    </div>
  )
}
